import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 通知
 */
const notifyMsg = {
  getNotifySmsMsg(startTime, endTime, status) {
    return axios.post(
      base.notifyMsg.getNotifySmsMsg,
      utils.postParamsArrayToJsonString({ startTime, endTime, status })
    );
  },
  /**
   * 查询站内短信
   */
  getNotifyMsg(startTime, endTime, type, status) {
    return axios.post(
      base.notifyMsg.getNotifyMsg,
      utils.postParamsArrayToJsonString({ startTime, endTime, type, status })
    );
  },
  /**
   * 修改站内短信状态
   */
  setNotifyMsgStatusToRead(ids) {
    return axios.post(
      base.notifyMsg.setNotifyMsgStatusToRead,
      utils.postParamsArrayToJsonString({ ids })
    );
  },
  /**
   * 修改站内短信状态
   */
  setAllNotifyMsgStatusToRead() {
    return axios.post(
      base.notifyMsg.setAllNotifyMsgStatusToRead,
      utils.postParamsArrayToJsonString({})
    );
  },
  /**
   * 业主发布站内短信到物业
   */
  pushNotifyMsgToMyProperties(rentalAreasId, title, message) {
    return axios.post(
      base.notifyMsg.pushNotifyMsgToMyProperties,
      utils.postParamsArrayToJsonString({ rentalAreasId, title, message })
    );
  },
  /**
   * 物业发布站内短信到租户
   */
  pushNotifyMsgToMyLessees(rentalAreasId, title, message) {
    return axios.post(
      base.notifyMsg.pushNotifyMsgToMyLessees,
      utils.postParamsArrayToJsonString({ rentalAreasId, title, message })
    );
  },

  // 获取消息总数
  getUnReadNotifyMsgCount() {
    return axios.post(base.notifyMsg.getUnReadNotifyMsgCount);
  },

  // 获取消息列表
  pageNotifyMsgInfoList(
    startTime,
    endTime,
    status,
    type,
    pageSize,
    currentPage
  ) {
    return axios.post(
      base.notifyMsg.pageNotifyMsgInfoList,
      utils.postParamsArrayToJsonString({
        startTime,
        endTime,
        status,
        type,
        pageSize,
        currentPage
      })
    );
  }
};

export default notifyMsg;
